import { prefersReducedMotion } from '../lib/lenis';

// The hero phone cycles through its screens, pausing while the pointer is over
// it. Tabs and pips jump straight to a screen. Under reduced motion it stops
// cycling but stays clickable.
export function initDevice(): void {
  document.querySelectorAll<HTMLElement>('[data-device-interval]').forEach((device) => {
    const slots = Array.from(device.querySelectorAll<HTMLElement>('[data-device-slot]'));
    const tabs = Array.from(device.querySelectorAll<HTMLElement>('[data-device-tab]'));
    const pips = Array.from(device.querySelectorAll<HTMLElement>('[data-device-pip]'));
    if (slots.length < 2) return;

    const interval = parseInt(device.dataset.deviceInterval || '5200', 10);
    device.style.setProperty('--device-interval', `${interval}ms`);

    let active = 0;
    let timer = 0;
    let paused = false;

    const show = (index: number): void => {
      active = (index + slots.length) % slots.length;

      slots.forEach((slot, i) => {
        const isActive = i === active;
        slot.classList.toggle('is-active', isActive);
        slot.toggleAttribute('aria-hidden', !isActive);
      });
      tabs.forEach((tab, i) => tab.classList.toggle('is-active', i === active));
      pips.forEach((pip, i) => {
        // Re-inserting the fill restarts its CSS animation.
        pip.classList.toggle('is-active', i === active);
        const fill = pip.firstElementChild;
        if (i === active && fill) pip.replaceChild(fill.cloneNode(true), fill);
      });
    };

    const schedule = (): void => {
      window.clearTimeout(timer);
      if (paused || prefersReducedMotion()) return;
      timer = window.setTimeout(() => {
        show(active + 1);
        schedule();
      }, interval);
    };

    const goTo = (index: number): void => {
      show(index);
      schedule();
    };

    tabs.forEach((tab, i) => tab.addEventListener('click', () => goTo(i)));
    pips.forEach((pip, i) => pip.addEventListener('click', () => goTo(i)));

    device.addEventListener('mouseenter', () => {
      paused = true;
      window.clearTimeout(timer);
    });
    device.addEventListener('mouseleave', () => {
      paused = false;
      schedule();
    });

    show(0);
    schedule();
  });
}
